import React from 'react';
import styles from './styles.module.scss';

interface I_Route {
    href: string | undefined;
    text: string;
    spliter?: string;
}

interface I_Props {
    routes: I_Route[];
}

const BreadCrumb: React.FC<I_Props> = ({ routes }) => {
    return (
        <div className="breadcrumb">
            {routes.map((anchor: I_Route, i: number) => (
                <span className={styles.anchor} key={i}>
                    {i !== 0 && (anchor.spliter || ` > `)}
                    {/* 配合 SEO，若沒有 href 時，則改為 span */}
                    {anchor.href ? (
                        <a className={styles.anchorText} href={anchor.href}>
                            {anchor.text}
                        </a>
                    ) : (
                        <span className={styles.anchorText}>{anchor.text}</span>
                    )}
                </span>
            ))}
        </div>
    );
};

export default BreadCrumb;
